import Swal from 'sweetalert2';

/**
 * Exibe um diálogo SweetAlert de confirmação para salvar alterações.
 * @param {Object} options - Opções customizáveis para o diálogo.
 * @param {string} [options.title] - Título do diálogo.
 * @param {string} [options.confirmButtonText] - Texto do botão de confirmar.
 * @param {string} [options.denyButtonText] - Texto do botão de negar.
 * @returns {Promise<'confirmed' | 'denied' | 'cancelled'>}
 */
export function showDialog(options = {}) {
  const t = options.t || ((x) => x);
  return Swal.fire({
    title: options.title ? t(options.title) : undefined,
    text: options.text ? t(options.text) : undefined,
    showDenyButton: options.denyButtonText !== undefined,
    showCancelButton: options.showCancelButton,
    showConfirmButton: options.showConfirmButton ?? true,
    confirmButtonText: options.confirmButtonText || 'OK',
    denyButtonText: options.denyButtonText,
    icon: options.icon,
    footer: options.footer,
    focusConfirm: options.focusConfirm,
    focusDeny: options.focusDeny,
    focusCancel: options.focusCancel,
  }).then(async (result) => {
    if (result.isConfirmed) {
      if (options.confirmed)
      {
        await options.confirmed()
      }
    } else if (result.isDenied) {
      if (options.denied)
      {
        await options.denied()
      }
    }

    if (options.cancelled)
    {
      await options.cancelled();
    }
  });
}
